export default __webpack_public_path__ + "static/admin1-3b3a80ee6f8d56e3b8ade5cb6c27d474.png";